import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { currentUser } = useAuth();

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    // Anonyme Nutzer müssen keine E-Mail verifizieren
    if (!currentUser.isAnonymous && !currentUser.emailVerified) {
        return <Navigate to="/verify-email" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;